<script>
  import Button from '$lib/components/Button.svelte';
  import Modal from '$lib/components/Modal.svelte';
  import { closeOverlayModal } from '$lib/features/app/modals';
  import { formatTimeLeft } from '$lib/utils/session';

  // expired: the session is over but the access token still works, so the
  // time left is until the logout.
  let { timeLeftMs, expired = false, onAcknowledge, onExtend } = $props();

  const acknowledge = () => {
    onAcknowledge();
    closeOverlayModal();
  };

  const extend = () => {
    onExtend();
    closeOverlayModal();
  };
</script>

<Modal
  title={expired
    ? 'Din session har gått ut'
    : 'Din session håller på att gå ut'}
  size="sm"
  isOverlay
  handleClose={acknowledge}
>
  <div class="w-full space-y-4">
    <p class="text-center text-gray-3">
      {#if expired}
        Du loggas ut om {formatTimeLeft(timeLeftMs)}. Spara ditt arbete.
      {:else}
        Din session går ut om {formatTimeLeft(timeLeftMs)}. Spara ditt arbete.
      {/if}
    </p>
    <p class="text-center text-sm text-gray-5">
      {expired ? 'Logga in igen' : 'Förläng sessionen genom att logga in igen'}
      i en ny flik för att fortsätta arbeta. Dina öppna flikar loggas inte ut.
    </p>
    <div class="flex justify-between gap-4">
      <div class="flex-1">
        <Button fullWidth onclick={acknowledge} variant="secondary">OK</Button>
      </div>
      <div class="flex-1">
        <Button fullWidth onclick={extend} variant="primary" autofocus={true}>
          Förläng session
        </Button>
      </div>
    </div>
  </div>
</Modal>
